import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { takePendingSso } from "plg/auth/ssoRedirect";
import { PLG_SIGNUP_ROUTE } from "constants/routes";

/**
 * Google returns here in the same tab. The code goes to the sign-in page in router state (never the URL), and
 * only when the state matches the sign-in this tab started; a cancel or a mismatch just shows the sign-in page.
 */
function GoogleOAuthCallbackPage() {
  const navigate = useNavigate();
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const pending = takePendingSso();
    const code = params.get("code");
    const ok = pending?.provider === "google" && !!code && params.get("state") === pending.state;
    navigate(PLG_SIGNUP_ROUTE, {
      replace: true,
      ...(ok ? { state: { sso: { provider: "google", code, codeVerifier: pending.codeVerifier } } } : {}),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <p className="plg-oauth-callback">Signing you in…</p>;
}

export default GoogleOAuthCallbackPage;
